import React from 'react';
import { Swimlane } from './Swimlane';

export function generateSwimlaneKey(children: React.ReactNode) {
  const childrenArr = React.Children.toArray(children);
  const sliderChild = childrenArr.find((child) => {
    if (React.isValidElement(child)) {
      return child.type === Swimlane.Slider;
    }

    return false;
  });

  if (!React.isValidElement<{ children: JSX.Element[] }>(sliderChild)) {
    throw new Error('🚫 You must provide a <Swimlane.Slider /> component as a direct child of <Swimlane />.');
  }

  return React.Children.map(sliderChild.props.children, (child) => {
    if (React.isValidElement(child)) {
      return child.key;
    }
  }).join();
}
